import useEditorStore from "../stores/useEditorStore";

const DistanceFromOrigin = 40; // Distance from origin for camera position
const CameraTransformValues = {
    upper: { position: [0, DistanceFromOrigin, 0], lookAt: [0, 0, 0] }, //Top
    bottom: { position: [0, -DistanceFromOrigin, 0], lookAt: [0, 0, 0] },   // Bottom
    front: { position: [0, 0, DistanceFromOrigin], lookAt: [0, 0, 0] }, // Front
    rear: { position: [0, 0, -DistanceFromOrigin], lookAt: [0, 0, 0] }, // Rear
    lateral: { position: [-DistanceFromOrigin, 0, 0], lookAt: [0, 0, 0] }, // Right
    mid: { position: [DistanceFromOrigin, 0, 0], lookAt: [0, 0, 0] }, // Left
};

export const CameraDirection = {
    UPPER: 'upper',
    BOTTOM: 'bottom',
    FRONT: 'front',
    REAR: 'rear',
    LATERAL: 'lateral',
    MID: 'mid',
}

const changeCameraDirection = (direction) => {

    const transformValues = CameraTransformValues[direction] || CameraTransformValues.front;
    const setCameraPosition = useEditorStore.getState().setCameraPosition;
    setCameraPosition({
        x: transformValues.position[0],
        y: transformValues.position[1],
        z: transformValues.position[2]
    });
};

export default changeCameraDirection;